@if (qrToken) {
  <div class="modal-backdrop fixed inset-0 bg-black/60 backdrop-blur-sm z-150 flex items-center justify-center p-4">
    <div
      class="modal-content bg-surface-dark border border-white/10 rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-hidden flex flex-col"
    >
      <div class="flex items-center justify-between p-6 border-b border-white/10">
        <div class="flex items-center gap-4">
          <div class="p-3 rounded-xl bg-primary/15">
            <span class="material-icons text-2xl text-primary">qr_code_2</span>
          </div>
          <div>
            <h2 class="text-xl font-semibold text-text-primary">QR-Code Vorschau</h2>
            <p class="text-sm text-text-muted">Mitarbeiter {{ label || '—' }}</p>
          </div>
        </div>
        <button type="button" class="p-2 rounded-xl text-text-muted hover:text-text-primary hover:bg-white/10 transition-all" (click)="onClose()">
          <span class="material-icons text-xl">close</span>
        </button>
      </div>

      <div class="flex-1 overflow-y-auto p-6">
        <div class="glass-card p-6 rounded-2xl flex flex-col items-center gap-4">
          <div class="w-full max-w-xs">
            <label for="qr-dimension" class="text-sm text-text-muted block mb-2">Abmessungen</label>
            <p-select
              inputId="qr-dimension"
              [(ngModel)]="selectedQrDimension"
              [options]="qrDimensionOptions"
              optionLabel="label"
              optionValue="value"
              placeholder="Abmessungen wählen"
              [filter]="false"
              [showClear]="false"
              styleClass="select-component-style"
              panelStyleClass="select-component-panel-style"
            >
              <ng-template pTemplate="selectedItem" let-option>
                <div class="option-row">
                  <span class="option-label">{{ option?.label }}</span>
                </div>
              </ng-template>

              <ng-template pTemplate="item" let-option>
                <div class="option-row">
                  <span class="option-label">{{ option.label }}</span>
                </div>
              </ng-template>
            </p-select>
          </div>

          <img [src]="getQrCodeImageUrl()" alt="QR-Code" class="w-32 h-32 rounded-lg bg-white p-2" />
          <p class="text-sm text-text-secondary text-center break-all">Token: {{ qrToken }}</p>
        </div>
      </div>

      <div class="flex items-center justify-end gap-3 p-6 border-t border-white/10 bg-white/2">
        <button type="button" class="btn-secondary" (click)="onClose()">Schließen</button>
        <button type="button" class="btn-primary flex items-center gap-2" (click)="downloadQrCode()">
          <span class="material-icons text-lg">download</span>
          Download
        </button>
      </div>
    </div>
  </div>
}
